import React, { memo } from "react";
import { StyleSheet, View } from "react-native";
import Carousel from "react-native-looped-carousel";
import entityStyle from "@utils/entityStyle";
import { isCLApp } from "../../config";
import CustomText from "../CustomText";
import useBannerCarouselContext, {
  BannerCarouselContextProvider,
} from "./BannerCarouselContext";
import RenderCMSEntity from "./RenderCMSEntity";

const BannerCarousel = memo((props) => {
  const {
    list_items = [],
    cl_title,
    cx_title,
    trackEvent,
    isPaddingVertical = true,
  } = props;
  const titleText = isCLApp ? cl_title : cx_title;
  const autoscroll = props.autoscroll ? props.autoscroll : false;
  const millis = props.autoscroll_millisecond
    ? props.autoscroll_millisecond
    : 3000;
  return (
    <BannerCarouselContextProvider>
      {list_items && list_items.length > 0 && (
        <View
          style={{
            marginTop: entityStyle.entityContainer.marginTop / 2,
            backgroundColor: "white",
            paddingVertical: isPaddingVertical ? 16 : 0,
          }}
        >
          {typeof titleText === "string" && titleText.trim().length ? (
            <CustomText variant="entityHeading">{titleText}</CustomText>
          ) : (
            <></>
          )}
          <View
            style={{
              position: "relative",
            }}
          >
            <MainCarousel {...{ list_items, trackEvent, autoscroll, millis }} />
          </View>
        </View>
      )}
    </BannerCarouselContextProvider>
  );
});

const MainCarousel = ({ list_items = [], trackEvent, autoscroll, millis }) => {
  const [value] = useBannerCarouselContext();
  return (
    <>
      {Array.isArray(list_items) && !!list_items.length ? (
        <Carousel
          bullets={true}
          bulletStyle={{
            height: 5,
            width: 5,
            backgroundColor: "rgba(255,255,255, 0.6)",
            borderRadius: 50,
            marginHorizontal: 3,
            borderWidth: 0,
          }}
          chosenBulletStyle={{
            height: 5,
            width: 8,
            backgroundColor: "#E40046",
            marginHorizontal: 3,
          }}
          bulletsContainerStyle={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            width: "100%",
            top: value.cta ? value.height - 79 : value.height - 18,
          }}
          style={{
            width: "100%",
            height: value.height + 10,
          }}
          autoplay={autoscroll}
          delay={millis}
          pageInfo={false}
        >
          {list_items.map((item) => (
            <RenderCMSEntity
              trackEvent={trackEvent}
              id={item.cms_item_id}
              key={item.cms_item_id}
              fromBannerCarousel={true}
              {...item}
            />
          ))}
        </Carousel>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  listHeader: {
    paddingHorizontal: 16,
    marginBottom: 4,
  },
});

export default BannerCarousel;
